import { z } from "zod";

const OmniTemplateSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().optional().describe("The subscription this template belongs to."),
    
    name: z.string().min(1, "Template name is required."),
    channelType: z.enum(['email', 'message']).describe("The channel this template is designed for."),
    
    subject: z.string().optional().nullable(),
    body: z.any().describe("The message content."),
    
    tags: z.array(z.string()).optional().default([]),
    isSystemDefault: z.boolean().optional().default(false).describe("Flag indicating if this is a system-provided default template."), // NEW FIELD

    providerTemplateId: z.string().optional().nullable().describe("The ID of this template on the provider's system (e.g., Meta)."),
    providerStatus: z.string().optional().nullable().describe("The approval status from the provider (e.g., PENDING, APPROVED, REJECTED)."),
    providerData: z.record(z.any()).optional().nullable().describe("Any other relevant data from the provider."),
    
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniTemplateSchema;